import { getBlocksAndPutIntoStore } from "../global-blocks/global-blocks";
import {
  convertPostsWithValidTreeToSingularitySectionLibrary,
  getPostsWithValidTreeFromRemote
} from "./library";
import { setSingularitySectionLibrary, isSingularitySectionLibraryLoaded } from "./library-singleton";
import { maybePopulateCurrentDocumentFromPageDescription } from "./singularity";

export function addListenersForSingularityToPopulatePageWithLibrarySections() {
  // Breakdance actions logic adds listeners twice... registerStoreActions is called twice.
  window.removeEventListener(
    "breakdance_document_ready",
    handleBreakdanceDocumentReady
  );
  window.addEventListener(
    "breakdance_document_ready",
    handleBreakdanceDocumentReady
  );
}

async function handleBreakdanceDocumentReady() {
  if (window.Breakdance.singularity) {
    // todo - this should probably use the mode in uiStore set by uiStore.setMode
    // todo - loadSingularitySectionLibrary should happen elsewhere, probably long before document is ready. it should probably happen when the editor is loaded.
    const success = await loadSingularitySectionLibrary();

    // Preload blocks so Inline Editor opens faster
    await getBlocksAndPutIntoStore();

    if (success) {
      maybePopulateCurrentDocumentFromPageDescription();
    }
  }
}

export async function loadSingularitySectionLibrary() {
  if (isSingularitySectionLibraryLoaded()) {
    console.log("Singularity section library already loaded, skipping");
    return true;
  }

  const posts = await getPostsWithValidTreeFromRemote();

  if (!posts) {
    alert("getPostsWithValidTreeFromRemote failed");
    console.log("getPostsWithValidTreeFromRemote failed");
    return false;
  }

  const singularitySectionLibrary =
    convertPostsWithValidTreeToSingularitySectionLibrary(posts);
  setSingularitySectionLibrary(singularitySectionLibrary);

  return true;
}
